import React from 'react';

import { Preview } from '@react-email/preview';
import { useRenderLiquidTemplate } from '@wp-block-builder/stores/WaypointRendererStore';

type PreheaderProps = {
  template: string | null | undefined;
  skipLiquid: boolean;
};
export default function Preheader({ template, skipLiquid }: PreheaderProps) {
  if (!template) {
    return null;
  }
  return <TemplatedPreheader template={template} skipLiquid={skipLiquid} />;
}

type TemplatedPreheaderProps = {
  template: string;
  skipLiquid: boolean;
};
function TemplatedPreheader({ template, skipLiquid }: TemplatedPreheaderProps) {
  const preview = useRenderLiquidTemplate({
    template,
    skipLiquid,
  });
  if (!preview || preview.trim().length === 0) {
    return null;
  }
  return <Preview>{preview}</Preview>;
}
